import { Component, Input, OnInit } from '@angular/core';
import { CNConsultation } from 'src/app/models/cnconsultation';

@Component({
  selector: 'app-contact-cardio-treatment',
  templateUrl: './contact-cardio-treatment.component.html',
  styleUrls: ['./contact-cardio-treatment.component.scss']
})
export class ContactCardioTreatmentComponent implements OnInit {

  private myContact: CNConsultation;

  constructor() { }

  ngOnInit(): void {
  }

  @Input() set contact(theContact: CNConsultation) {
    this.myContact = theContact;
  }

  get contact(): CNConsultation {
    return this.myContact;
  }

}
